const KEY = 'munibus_admin_token';

export function getAdminToken() {
  try {
    const persisted = localStorage.getItem(KEY);
    const sessionOnly = sessionStorage.getItem(KEY);
    // Preferir token persistido (Recordarme). Si quedó sesión vieja en otra pestaña,
    // no debe tapar el JWT guardado en localStorage.
    if (persisted) return persisted;
    return sessionOnly || '';
  } catch {
    return '';
  }
}

/**
 * @param {string} token
 * @param {{ persist?: boolean }} [opts] — persist: guardar en localStorage (recordarme); si no, solo sesión (pestaña).
 */
export function setAdminToken(token, opts = {}) {
  const persist = Boolean(opts?.persist);
  try {
    if (!token) {
      sessionStorage.removeItem(KEY);
      localStorage.removeItem(KEY);
      return;
    }
    if (persist) {
      try {
        localStorage.setItem(KEY, token);
        sessionStorage.removeItem(KEY);
      } catch {
        // Safari modo privado / cuota: al menos sesión en esta pestaña
        try {
          sessionStorage.setItem(KEY, token);
        } catch {
          /* ignore */
        }
      }
    } else {
      sessionStorage.setItem(KEY, token);
      try {
        localStorage.removeItem(KEY);
      } catch {
        /* ignore */
      }
    }
  } catch {
    /* ignore */
  }
}

export function clearAdminToken() {
  setAdminToken('');
}
